import ViewAllocateBudget from '../../../components/Multi/BudgetAllocation/ViewAllocateBudget';
const ViewBudgetPage = () => {
    return (
        <div>
            <ViewAllocateBudget />
        </div>
    )
}

export default ViewBudgetPage
